import { useEffect, useState } from 'react'

interface ConfirmDeleteModalProps {
  isOpen: boolean
  title?: string
  message: string
  onConfirm: () => void
  onCancel: () => void
  countdownSeconds?: number
}

export function ConfirmDeleteModal({
  isOpen,
  title = 'Conferma eliminazione',
  message,
  onConfirm,
  onCancel,
  countdownSeconds = 3,
}: ConfirmDeleteModalProps) {
  const [secondsLeft, setSecondsLeft] = useState(countdownSeconds)

  useEffect(() => {
    if (!isOpen) return
    setSecondsLeft(countdownSeconds)
    const interval = setInterval(() => {
      setSecondsLeft(s => (s > 0 ? s - 1 : 0))
    }, 1000)
    return () => clearInterval(interval)
  }, [isOpen, countdownSeconds])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="card w-full max-w-md">
        <div className="p-6 border-b flex items-center justify-between">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button onClick={onCancel} className="btn-ghost p-1 text-slate-400">✕</button>
        </div>
        <div className="p-6">
          <p className="text-sm whitespace-pre-line text-slate-700">{message}</p>
        </div>
        <div className="p-6 pt-0 flex justify-end gap-3">
          <button onClick={onCancel} className="btn-secondary">Annulla</button>
          <button
            onClick={onConfirm}
            disabled={secondsLeft > 0}
            className="btn bg-red-600 hover:bg-red-700 text-white disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {secondsLeft > 0 ? `Elimina (${secondsLeft})` : 'Elimina'}
          </button>
        </div>
      </div>
    </div>
  )
}
